import React, { useEffect } from 'react';
import './HeatingModeButtons.css'; // Create this file for styling the buttons

const config = require('../config');

const HeatingModeButtons = ({selectedMode, setSelectedMode }) => {
  const token = localStorage.getItem('token');

  useEffect(() => {
    fetch(config.serverUrl + '/heating-value?env=villa&name=heatingmode',  {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(response => response.json())
      .then(data => setSelectedMode(data.value));    
  }, [token, setSelectedMode]);

  const handleModeChange = (mode) => {
    setSelectedMode(mode);

    fetch(config.serverUrl + '/heating-value', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        "env": "villa",
        "name": "heatingmode",
        "value": mode
      })
    })
    .catch(error => { console.log(error); });    
  };

  return (
    <div className="heating-mode-buttons">
      <button
        className={selectedMode === 'Manual' ? 'selected' : ''}
        onClick={() => handleModeChange('Manual')}
      >
        Manual
      </button>
      <button
        className={selectedMode === 'Home' ? 'selected' : ''}
        onClick={() => handleModeChange('Home')}
      >
        Home
      </button>
      <button
        className={selectedMode === 'Away' ? 'selected' : ''}
        onClick={() => handleModeChange('Away')}
      >
        Away
      </button>
    </div>
  );
};

export default HeatingModeButtons;